import React, { FC } from 'react';
import _ from 'lodash';
import { TemplateGalleryCard } from '@common/types';
import TemplateCardAdaptive from '@components/Templates/TemplateGallery/TemplateCard/TemplateCardAdaptive';
import s from './FeaturedTemplatesMobile.module.scss';

type Props = {
  templates: TemplateGalleryCard[];
};

const FeaturedTemplatesMobile: FC<Props> = ({ templates }) => {
  return (
    <div className={s.templatesMobile}>
      {_.map(templates, (template, index) => (
        <TemplateCardAdaptive
          key={template.id}
          isMobileView={true}
          template={template}
          index={index}
        />
      ))}
    </div>
  );
};

export default FeaturedTemplatesMobile;
